module.exports = __webpack_public_path__ + "static/media/7D.58d872f0.png";